module.exports = __webpack_public_path__ + "assets/images/ios_ride_this-312c9470223ba5f18e7be06f4479e4da.mp4";